import { Button, Stack, useTheme } from "@mui/material";
import { Plus } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	onClick?: () => void;
};

export const PaperworkAddDocumentButton: FC<Props> = ({ onClick }) => {
	const { palette } = useTheme();
	const { t } = useResource();

	return (
		<Stack
			mt={0.8}
			bgcolor={palette.background.paper}
			borderTop={1}
			borderBottom={1}
			borderColor={palette.grey[100]}
		>
			<Button
				variant="listCta"
				startIcon={<Plus size={16} aria-hidden />}
				onClick={onClick}
			>
				{t(Resources.Paperwork.addDocument)}
			</Button>
		</Stack>
	);
};
